import { css } from "@emotion/react";

export const canvasMargin = css`
    margin: 1rem;
`;

export const loadingPlaceHolder = css`
    height: 480px;
    width: 640px;
`;
